/**
 * Item J's words that need the catalogue: a backup's age, a schedule, a
 * storage id and the clean-up line. Shared by the block under the figures
 * and the "Varundus" tab, so the two never word the same fact differently.
 * The rules behind them live in `lib/monitoringBackup.ts`.
 */
import {
  ageMessage,
  cleanupState,
  scheduleKey,
  storageKey,
} from "../../../../lib/monitoringBackup";
import type { ReporterDatabaseView } from "../../../../lib/monitoringReporter";
import { fmtDateTime } from "../../../ui";
import type { T } from "../words";

/** "5 tundi tagasi". */
export function agoText(t: T, iso: string, now: number): string {
  const m = ageMessage(iso, now);
  return t(m.key, m.vars);
}

/** A schedule in words; a slug this CRM does not know as itself, none as "-". */
export function scheduleText(t: T, slug: string | null | undefined): string {
  if (!slug) return "-";
  const key = scheduleKey(slug);
  return key ? t(key) : slug;
}

/** A storage id in words; an id this CRM does not know as itself. */
export function storageText(t: T, id: string): string {
  const key = storageKey(id);
  return key ? t(key) : id;
}

/** WP-Optimize's clean-up in one line, or null when the report carries no database part. */
export function cleanupText(t: T, db: ReporterDatabaseView | null): string | null {
  const state = cleanupState(db);
  if (state === "unknown") return null;
  const c = db?.cleanup;
  if (state !== "on" || !c) return t(`monitoring.reporter.backup.cleanup.${state}`);
  const every = scheduleText(t, c.every);
  return c.lastRunAt
    ? t("monitoring.reporter.backup.cleanup.on", { every, when: fmtDateTime(c.lastRunAt) })
    : t("monitoring.reporter.backup.cleanup.onNever", { every });
}
